<script>
	export let value = "";
	export let placeHolder = "";
	export let length = 0;
	export let lowCase = false;
	export let reset = false;
	export let callback = null;

	let edit = value === undefined || value.trim().length == 0;

	function onKey(e) {
		if (e.keyCode == 13 || (length > 0 && value.trim().length == length))
			process();
	}

	function onEnd(e) {
		if (edit && (!length || value.trim().length == length))
			process();
	}

	function process() {
		value = value.trim();
		if (value.length == 0)
			return;
		if (lowCase)
			value = value.toLowerCase();
		if (callback)
			callback(value);
		if (reset)
			value = "";
		else
			edit = false;
	}
</script>

{#if edit}
	<input
		bind:value={value}
		placeholder={placeHolder}
		on:keyup={onKey}
		on:focusout={onEnd}
	/>
{:else}
	<span class="clickable" on:click={() => edit = true}>{value}</span>
{/if}
